module.exports = __webpack_public_path__ + "076c6adde1ee78fa4520c685499e4d71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icn-viacom-200.png
// module id = 1544
// module chunks = 0